export const AGENT_SEARCH_PARAM = "agent";
export const AGENT_PROJECT_ID_SEARCH_PARAM = "projectId";
export const AGENT_TASK_ID_SEARCH_PARAM = "taskId";
export const AGENT_ACTIVITY_ID_SEARCH_PARAM = "activityId";

export enum AgentSurfaceId {
  Overview = "overview",
  Projects = "projects",
  Project = "project",
  Tasks = "tasks",
  Task = "task",
  Activities = "activities",
  Activity = "activity",
}

export type AgentOverlayState =
  | { surfaceId: AgentSurfaceId.Overview }
  | { surfaceId: AgentSurfaceId.Projects }
  | { surfaceId: AgentSurfaceId.Project; projectId: string }
  | { surfaceId: AgentSurfaceId.Tasks }
  | { surfaceId: AgentSurfaceId.Task; taskId: string }
  | { surfaceId: AgentSurfaceId.Activities }
  | { surfaceId: AgentSurfaceId.Activity; activityId: string };

export type AgentEntityRouteParamName = "projectId" | "taskId" | "activityId";
